<ng-container>
  <div
    class="flyout-container"
    [ngStyle]="{ top: scrollPosition.y === 0 ? '116px' : '79px' }"
  >
    <div class="container flyout">
      <div *ngIf="showFlyoutContent" @flyoutAnimation>
        <div class="flyout__header">
          <div class="flyout__header--overview">
            <hdi-link
              [type]="LinkType.NOSTYLES"
              [label]="'Zur Übersicht ' + title | capitalize"
              [title]="'Zur Übersicht ' + title | capitalize"
              (click)="navigateToOverview()"
              [iconName]="'grid-horizontal'"
            ></hdi-link>
          </div>
          <hdi-icon
            class="flyout__close"
            [iconName]="'xmark'"
            (click)="close()"
          ></hdi-icon>
        </div>
        <div class="container">
          <div *ngIf="isSimple">
            <div class="flyout__item--container">
              <div *ngFor="let item of pages; let idx = index">
                <hdi-link
                  class="flyout__item"
                  [type]="LinkType.PRIMARY_ARROW"
                  [label]="item.title | capitalize"
                  [title]="item.title | capitalize"
                  [href]="item.url"
                  (click)="close()"
                ></hdi-link>
              </div>
            </div>
          </div>
          <div *ngIf="!isSimple">
            <div class="flyout__item__container--extended">
              <div *ngFor="let item of pages; let idx = index">
                <div class="flyout__item--topic">
                  <hdi-link
                    class="flyout__item--extended"
                    [type]="LinkType.PRIMARY_ARROW"
                    [label]="item.title | capitalize"
                    [title]="item.title | capitalize"
                    [href]="item.url"
                  ></hdi-link>
                  <ng-container *ngIf="item.subpages">
                    <hdi-link
                      *ngFor="let subitem of item.subpages"
                      class="flyout__subitem"
                      [type]="LinkType.PRIMARY_ARROW"
                      [label]="subitem.title | capitalize"
                      [title]="subitem.title | capitalize"
                      [href]="subitem.url"
                      (click)="close()"
                    ></hdi-link>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flyout-overlay" (click)="close()"></div>
</ng-container>
